module.exports = __webpack_public_path__ + "static/media/material_arrow_down_blue.adbf6b18.svg";